import { Transform } from 'class-transformer';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { JsonTransform } from '@/utils/value-transformers/json.transform';

export default class ConversationMessageContentModel {
  @Transform(JsonTransform)
  data!: IKeyValue<IKeyValue<string | string[] | IKeyValue<string | string[]>[]>>;
}
